import SuccessCheckmark from './SuccessCheckmark';
import LoopPin from './LoopPin';
import Delete from './Delete';
import Truck from './Truck';
import Calendar from './Calendar';
import Wallet from './Wallet';
import Map from './Map';
import Email from './Email';
import Locker from './Locker';
import LockerWithArrow from './LockerWithArrow';
import MapWithPin from './MapWithPin';
import Barcode from './Barcode';
import QRcode from './QRcode';
import Heart from './Heart';
import MethodPreference from './MethodPreference';
import PreferenceStatus from './PreferenceStatus';
import Chevron from './Chevron';
import Close from './Close';
import ArrowRight from './ArrowRight';
import ExchangeArrow from './ExchangeArrow';

export default {
  SuccessCheckmark,
  LoopPin,
  Delete,
  Truck,
  Calendar,
  Wallet,
  Map,
  Email,
  Locker,
  LockerWithArrow,
  MapWithPin,
  Barcode,
  QRcode,
  Heart,
  MethodPreference,
  PreferenceStatus,
  Chevron,
  Close,
  ArrowRight,
  ExchangeArrow,
};
